/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineUsageV2 } from '../../models/machine-usage-v-2';

export interface ApiV0MachineUsageCompanyCompanyIdGet$Plain$Params {
  companyId: string;
}

export function apiV0MachineUsageCompanyCompanyIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiV0MachineUsageCompanyCompanyIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineUsageV2>>> {
  const rb = new RequestBuilder(rootUrl, apiV0MachineUsageCompanyCompanyIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineUsageV2>>;
    })
  );
}

apiV0MachineUsageCompanyCompanyIdGet$Plain.PATH = '/api/v0/machine-usage/company/{companyId}';
